const dashboard = {
  CreateNewJob: 'Create New Job',
  JobListings: {
    Title: 'Job Listings',
    Filter: {
      Status: 'Status',
    },
    Sort: {
      Priority: 'Priority first',
    },
  },
};

export default dashboard;
